import { message } from "antd";
import { LOGIN, VERIFY_TOKEN } from "../constants/url";
import httpBase from "../utils/http.utils";
import { storeAuthToken, storeUserData } from "../store/slices/profile.slice";

const getAllowedRouteNames = (navPermissions) =>
  Object.entries(navPermissions || {})
    .filter(([, isAllowed]) => isAllowed === true)
    .map(([routeName]) => routeName);

const getStoredUserData = () => {
  try {
    return JSON.parse(localStorage.getItem("userData") || "{}");
  } catch {
    return {};
  }
};

const getStoredNavPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem("nav_permissions") || "[]");
  } catch {
    return [];
  }
};

const setLocalStorageValue = (key, value) => {
  if (value === undefined || value === null) return;
  localStorage.setItem(key, String(value));
};

const syncUserSessionData = (responseData, dispatch) => {
  const storedUserData = getStoredUserData();
  const navPermissions = responseData?.nav_permission;
  const hasNavPermissions =
    navPermissions && typeof navPermissions === "object" && !Array.isArray(navPermissions);
  const allowedRouteNames = hasNavPermissions
    ? getAllowedRouteNames(navPermissions)
    : getStoredNavPermissions();

  const userData = {
    ...storedUserData,
    ...responseData,
    ...(hasNavPermissions ? { nav_permission: navPermissions } : {}),
    nav_permissions: allowedRouteNames,
  };

  dispatch(
    storeUserData({
      id: userData?.id,
      username: userData?.username,
      role: userData?.role,
      tenant_id: userData?.tenant_id,
      tenant_label: userData?.tenant_label,
      nav_permissions: allowedRouteNames,
      nav_permission: hasNavPermissions ? navPermissions : userData?.nav_permission,
    })
  );

  localStorage.setItem("userData", JSON.stringify(userData));
  setLocalStorageValue("userId", userData?.id);
  setLocalStorageValue("username", userData?.username);
  setLocalStorageValue("role", userData?.role);
  setLocalStorageValue("tenant_id", userData?.tenant_id);
  setLocalStorageValue("tenant_label", userData?.tenant_label);
  setLocalStorageValue("slug", userData?.tenant_slug || userData?.slug);
  localStorage.setItem("nav_permissions", JSON.stringify(allowedRouteNames));
};

export const loginApi = ({ data, finalCallback, successCallback }) => {
  return async (dispatch) => {
    try {
      const { keepSignedIn = true, ...loginPayload } = data;
      const response = await httpBase().post(LOGIN, new URLSearchParams(loginPayload));

      if (response?.data?.access_token) {
        const loginResponseData = response?.data || {};

        dispatch(
          storeAuthToken({
            token: loginResponseData?.access_token,
            keepSignedIn,
          })
        );
        syncUserSessionData(loginResponseData, dispatch);
        // const tenantSlug = (response?.data?.tenant_label || "")
        //   .split(" ")
        //   .join("");
        // localStorage.setItem("slug", tenantSlug);

        // ...
        successCallback(response);
        message.success(`Welcome ${response?.data?.username}`);
      } else {
        // message.error("Something went wrong with the login!");
        const errorMessage =
          response?.data?.detail || "Something went wrong with the login";
        message.error(errorMessage);
      }
    } catch (e) {
      message.error(
        e?.response?.data?.detail || "Something went wrong with the login"
      );
    } finally {
      finalCallback();
    }
  };
};

export const verifyTokenApi = ({
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().get(VERIFY_TOKEN);
      if (response?.data?.valid) {
        syncUserSessionData(response.data, dispatch);
      }
      successCallback?.(response?.data);
    } catch (e) {
      failureCallback?.(e);
    } finally {
      finalCallback?.();
    }
  };
};
